import React, { useState } from "react";
import "./IslamicTrade.css";

import { Link } from "react-router-dom";
import BadgePopup from "../components/Badgepopup";
import FloatingPageNav from "../components/FloatingPageNav";
import Question from "../components/Question";

function DIY98() {
  


  return (
    <div className="container">
   
      <h1>DIY 98</h1>
        
      <h2>Work In Progress</h2>
      {/* <p className="content">
       */}
      
      
      
      
      
      
      {/* <b>Summary of Today’s Lesson</b>
        <br />
        <br />
         <b> Coming Up Next</b>
        <br />
        <br />
      </p>
      <h2>Test your understanding</h2> */}
      
    </div>
  );
}

export default DIY98;
